import { gql } from 'graphql-request';
import {
  AI_FLOW_QUERY_FRAGMENT,
  AI_PROMPT_QUERY_FRAGMENT,
} from './ai-prompts-gql';

export const TRANSCRIPTION_QUERY_FRAGMENT = `
{
  jobStatus
  audio {
    url
  }
  elementsJson {
    id
    url
  }
  waveformData {
    id
    url
  }
}`;

export const CUSTOMER_TYPE_QUERY_FRAGMENT = gql`
{
  clipProducerTemplates ${AI_FLOW_QUERY_FRAGMENT}
  blogTemplates ${AI_PROMPT_QUERY_FRAGMENT}
  socialPostTemplates ${AI_PROMPT_QUERY_FRAGMENT}
  emailTemplates ${AI_PROMPT_QUERY_FRAGMENT}
  shareableImagesTemplates ${AI_PROMPT_QUERY_FRAGMENT}
  talkingPointsTemplate ${AI_PROMPT_QUERY_FRAGMENT}
}
`;

export const CUSTOMER_TYPE_DEFAULT_TEMPLATES_QUERY = gql`
  query getDefaultCustomerType {
    customerType(filter: { title: { eq: "Default" } })
      ${CUSTOMER_TYPE_QUERY_FRAGMENT}
  }
`;
